import {createApp} from 'vue'
import UserPostsList from './UserPostsList'

const el = '.kb-component--user-posts-list'

export default function(Store) {
    const DOM = document.querySelectorAll(el)
    if( DOM.length) {
        DOM.forEach((UserPostsListDOM) => {
            const exturnalData = UserPostsListDOM.dataset.exturnal ? JSON.parse(UserPostsListDOM.dataset.exturnal) : null
            const props = {
                guid: UserPostsListDOM.dataset.guid,
                groupId: UserPostsListDOM.dataset.groupId,
                skip: parseInt(UserPostsListDOM.dataset.skip) ?? 0,
                take: parseInt(UserPostsListDOM.dataset.take) ?? 10,
                userData: exturnalData?.userData ?? null,
                type: UserPostsListDOM.dataset.type?? null,
            }
            const component = createApp(UserPostsList, props).use(Store)
            component.mount(UserPostsListDOM)
        })
    }
}